import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IonButton } from '@ionic/angular/standalone';

import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
    selector: 'lib-rating-star',
    standalone: true,
    imports: [CommonModule, SvgIconComponent, IonButton],
    templateUrl: './rating-star.component.html',
    styleUrl: './rating-star.component.css'
})
export class RatingStarComponent {
    /* eslint-disable */
    @Input() display: 'fill' | 'half' | 'empty' = 'empty';
    @Input() isClickable: boolean = false;
    @Input() size: number = 16;

    @Output() onStarClick = new EventEmitter();

    onClick() {
        this.onStarClick.emit();
    }
}
